import { render } from "./LimitationCalculator.vue?vue&type=template&id=20e02a75&scoped=true"
import script from "./LimitationCalculator.vue?vue&type=script&lang=js"
export * from "./LimitationCalculator.vue?vue&type=script&lang=js"

import "./LimitationCalculator.vue?vue&type=style&index=0&id=20e02a75&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e02a75"]])

export default __exports__